import React, {useEffect } from "react";
import { ChevronLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import apilink from "../globals/Baseurls";
import axios from "axios";
import "react-activity/dist/library.css";

const MemberBirthday = () => {
  const navigate = useNavigate();
  const [birthdayToday, setBirthdayToday] = React.useState([]);
  const [birthdayClose, setBirthdayClose] = React.useState([]);
  const [birthdayPast, setBirthdayPast] = React.useState([]);


  useEffect(() => {
    const getAsyncData = async () => {
      const familyData = await JSON.parse(
        localStorage.getItem("userFamilyData")
      );

      //Today
      const baseUrl = apilink.link;
      await axios
        .get(`${baseUrl}/family/members/birthday/${familyData.record.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          if (response.data.message == "Successfull") {
            setBirthdayToday(response.data.records);
          }
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });

      //Close
      await axios
        .get(
          `${baseUrl}/family/members/birthdayclose/${familyData.record.familycode}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )

        .then((response) => {
          if (response.data.message == "Successfull") {
            setBirthdayClose(response.data.records);
          }
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });

      //Past
      await axios
        .get(
          `${baseUrl}/family/members/birthdaypast/${familyData.record.familycode}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )

        .then((response) => {
          if (response.data.message == "Successfull") {
            setBirthdayPast(response.data.records);
          }
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    };
    getAsyncData();
  }, []);
  return (
    <>
      <div
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <h4 onClick={()=>navigate("/app/more")} style={{ fontFamily: "Open Sans", fontSize: 17 }}>
          <ChevronLeft size={20} style={{ color: "#ffffff" }} />
        </h4>
        <h4 style={{ fontFamily: "Open Sans", fontSize: 17, color: "#ffffff" }}>
          <b>More /</b> Member Birthdays
        </h4>
      </div>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <div
          style={{
            alignItems: "center",
            paddingInline: "10px",
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#779d3820",
            height: "50px",
            width: "100%",
            borderRadius: "5px",
          }}
        >
          <h4
            style={{ fontFamily: "Open Sans", fontSize: 20, color: "#779d38" }}
          >
            Today Birthdays ({birthdayToday.length})
          </h4>
        </div>
        {birthdayToday.map((person) => (
          <>
            <div
              key={person.id}
              style={{ flexDirection: "column", marginBottom: "30px" }}
            >
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <b>
                    {person.alias} {person.surname}
                  </b>
                  <h6 style={{ fontFamily: "Open Sans" }}>
                    {person.parent != null && (
                      <>
                        {person.gender == "Female" ? "Daughter Of" : "Son Of"}{" "}
                      </>
                    )}
                    {person.parent == null ? "Root Member" : person.parentname}
                  </h6>
                  {person.parent != null && (
                    <>
                      <h6 style={{ fontFamily: "Open Sans" }}>
                        Child Number: {person.born}
                      </h6>
                    </>
                  )}
                </div>
                <div>
                <span className="float-end" style={{ fontFamily: "Open Sans" }}>
                    {person.residance}
                  </span>
                  <br></br>
                  <span
                    className="float-end"
                    style={{ fontFamily: "Open Sans" }}
                  >
                    {person.phone}
                  </span>
                  <br></br>
                  <span
                    className="float-end"
                    style={{ fontFamily: "Open Sans" }}
                  >
                    <b>
                    Birthday: {person.actualdob}
                  </b>
                  </span>
                </div>
              </div>
            </div>
          </>
        ))}
      </div>

      {/* Close Birthdays*/}
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <div
          style={{
            alignItems: "center",
            paddingInline: "10px",
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#779d3820",
            height: "50px",
            width: "100%",
            borderRadius: "5px",
          }}
        >
          <h4
            style={{ fontFamily: "Open Sans", fontSize: 20, color: "#779d38" }}
          >
            Close Birthdays ({birthdayClose.length})
          </h4>
        </div>
        {birthdayClose.map((person) => (
          <>
            <div
              key={person.id}
              style={{ flexDirection: "column", marginBottom: "30px" }}
            >
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <b>
                    {person.alias} {person.surname}
                  </b>
                  <h6 style={{ fontFamily: "Open Sans" }}>
                    {person.parent != null && (
                      <>
                        {person.gender == "Female" ? "Daughter Of" : "Son Of"}{" "}
                      </>
                    )}
                    {person.parent == null ? "Root Member" : person.parentname}
                  </h6>
                  {person.parent != null && (
                    <>
                      <h6 style={{ fontFamily: "Open Sans" }}>
                        Child Number: {person.born}
                      </h6>
                    </>
                  )}
                </div>
                <div>
                <span className="float-end" style={{ fontFamily: "Open Sans" }}>
                    {person.residance}
                  </span>
                  <br></br>
                  <span
                    className="float-end"
                    style={{ fontFamily: "Open Sans" }}
                  >
                    {person.phone}
                  </span>
                  <br></br>
                  <span
                    className="float-end"
                    style={{ fontFamily: "Open Sans" }}
                  >
                    <b>
                    Birthday: {person.actualdob}
                  </b>
                  </span>
                </div>
              </div>
            </div>
          </>
        ))}
      </div>

      {/* Past Birthdays*/}
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <div
          style={{
            alignItems: "center",
            paddingInline: "10px",
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#779d3820",
            height: "50px",
            width: "100%",
            borderRadius: "5px",
          }}
        >
          <h4
            style={{ fontFamily: "Open Sans", fontSize: 20, color: "#779d38" }}
          >
            Past Birthdays ({birthdayPast.length})
          </h4>
        </div>

        {birthdayPast.map((person) => (
          <>
            <div
              key={person.id}
              style={{ flexDirection: "column", marginBottom: "30px" }}
            >
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <b>
                    {person.alias} {person.surname}
                  </b>
                  <h6 style={{ fontFamily: "Open Sans" }}>
                    {person.parent != null && (
                      <>
                        {person.gender == "Female" ? "Daughter Of" : "Son Of"}{" "}
                      </>
                    )}
                    {person.parent == null ? "Root Member" : person.parentname}
                  </h6>
                  {person.parent != null && (
                    <>
                      <h6 style={{ fontFamily: "Open Sans" }}>
                        Child Number: {person.born}
                      </h6>
                    </>
                  )}
                </div>
                <div>
                  <span className="float-end" style={{ fontFamily: "Open Sans" }}>
                    {person.residance}
                  </span>
                  <br></br>
                  <span
                    className="float-end"
                    style={{ fontFamily: "Open Sans" }}
                  >
                    {person.phone}
                  </span>
                  <br></br>
                  <span
                    className="float-end"
                    style={{ fontFamily: "Open Sans" }}
                  >
                    <b>
                    Birthday: {person.actualdob}
                  </b>
                  </span>
                </div>
              </div>
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default MemberBirthday;
